export const DEFAULT_DOCUMENT_LABEL = 'document';

export type DocumentAction = 'view' | 'replace' | 'choose' | 'download' | 'downloadTemplate';

export const getDocumentLabel = (
  documentName?: string | null,
  documentType?: string | null,
  typeTitle?: string | null
): string => {
  const cleanedName = documentName?.replace(/\s*\*+\s*$/, '').trim();
  const title = typeTitle?.trim();

  if (title) return title;
  if (cleanedName) return cleanedName;
  if (documentType?.trim()) return documentType.trim();
  return DEFAULT_DOCUMENT_LABEL;
};

export const getDocumentActionAriaLabel = (
  action: DocumentAction,
  documentName?: string | null,
  documentType?: string | null,
  typeTitle?: string | null
): string => {
  const label = getDocumentLabel(documentName, documentType, typeTitle);

  switch (action) {
    case 'view':
      return `View ${label}`;
    case 'replace':
      return `Replace ${label}`;
    case 'choose':
      return `Choose file for ${label}`;
    case 'download':
      return `Download ${label}`;
    case 'downloadTemplate':
      return `Download template for ${label}`;
    default:
      return label;
  }
};